<script>
import { Account, Location,ShoppingCart, Merchant } from './../../functions.js'

import AccountAPI from './../../api/account.js'
import ProductAPI from './../../api/product.js'

import HeaderFive from './../shared/HeaderFive.vue'
import Footer from './../shared/Footer.vue'

import AlertDialogue from './../shared/AlertDialogue.vue'
import ConfirmDialogue from './../shared/ConfirmDialogue.vue'

export default {
  name: 'Login',
  components: {
    Footer,
    HeaderFive,
    AlertDialogue,
    ConfirmDialogue
  },
  
  watch: {
    show_error (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value == true) {
        setTimeout(() => {
          this.show_error = false
          this.error_message = ''
        }, 10000)
      }
    }
  },
  mounted()
  {
    if(this.$route.query.m == 'user_logout')
    {
      this.show_error = true;
      this.error_message = 'You are now logged out';
      this.$refs['signin'].scrollIntoView({ behavior: 'smooth', block: "center" });
    } else if(this.$route.query.m == 'session_expired')
    {
      this.show_error = true;
      this.error_message = 'Your session has expired';
      this.$refs['signin'].scrollIntoView({ behavior: 'smooth', block: "center" });
    } else if(this.$route.query.m == "unauthorized")
    {
      this.show_error = true;
      this.error_message = 'Please sign-in or register an account to proceed to checkout';
      this.$refs['signin'].scrollIntoView({ behavior: 'smooth', block: "center" });
      // Dont show error message. just display a popup
      // this.$refs.alertDialogue.show({
      //     title: "Unable to Checkout",
      //     message: "Please sign-in or register an account to proceed to checkout.",
      //     okButton: 'Ok',
      // });
    }
  },
  methods: {
    async loadAccountCart(login_id, token, barangay_code, merchant_id, change_merchant = true)
    {
        return new Promise((resolve, reject) => {
            try {
              var account_cart = AccountAPI.myCart(login_id, token, barangay_code, change_merchant);
              account_cart.then((response) => {
                if(response.status == "success")
                {
                    var sku_list = [];
                    var query_cart = response.cart;
                    var current_cart = ShoppingCart.cart[ShoppingCart.active_shopping_cart].products;
                    var product_quantity = [];

                    current_cart.forEach((product,product_index)=>{
                        var raw_sku = product.product.sku.substring(0, product.product.sku.indexOf("-"));
                        sku_list.push(raw_sku);
                        product_quantity.push(product.quantity);
                    });


                    query_cart.forEach((product,product_index)=>{
                        var raw_sku = product.sku_id.substring(0, product.sku_id.indexOf("-"));
                        var raw_merchant = product.sku_id.substring(product.sku_id.indexOf("-") + 1);

                          console.log(raw_merchant);
                          console.log(merchant_id);
                        if(raw_merchant == merchant_id)
                        {
                          sku_list.push(raw_sku);
                          product_quantity.push(product.quantity);
                        }
                    });


                    if(sku_list.length)
                    {

                        
                        var products_request = ProductAPI.getProducts(barangay_code, '', '','', false, false, 'best_seller', 'none', '', 12, 0, sku_list)
                          products_request.then((response) => {
                            
                            if(response.products.length)
                            {
                              var new_products = response.products;

                              if(current_cart.length)
                              {
                                   var updated_user_cart = [];
                                   current_cart.forEach((cur_product, cur_product_index)=>{
                                    new_products.forEach((product, product_index)=>{
                                        
                                        var cur_raw_sku = cur_product.product.sku.substring(0, cur_product.product.sku.indexOf("-"));
                                        var new_raw_sku = product.sku.substring(0, product.sku.indexOf("-"));

                                        if(new_raw_sku == cur_raw_sku)
                                        {
                                            updated_user_cart.push({
                                                'product': product,
                                                'quantity': cur_product.quantity,
                                            });
                                        }
                                    
                                      });
                                   });
                                    
                                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products = updated_user_cart;
                                     ShoppingCart.setCart(ShoppingCart.cart); 
                                     resolve(true);
                              }
                              else
                              {
                                  new_products.forEach((product, product_index)=>{
                                      var x = ShoppingCart.addToCart(product, product_quantity[product_index]);
                                      x.then((add_to_cart)=>{
                                      });
                                  });
                                  resolve(true);

                              }
                            }
                            else
                            {
                              ShoppingCart.setCart(ShoppingCart.EMPTY_CART);
                              resolve(true);
                            }
                         
                        });

                    }
                    else
                    {
                      resolve(true);
                    }
                }
                else
                {
                    resolve(false);
                }
              })
            } catch (error) {
             resolve(false);
            }
        });
    },
    validate () {
      var error = {
        message: '',
        has_error: 0
      }

      if (this.username.trim() == '') {
        error.message = 'Please enter your Email Address'
        error.has_error = 1
        return error
      } 
      else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.username.trim()))) {
        error.message = 'Please enter a valid Email Address'
        error.has_error = 1
        return error
      } 
      else if (this.password.trim() == '') {
        error.message = 'Please enter your Password'
        error.has_error = 1
        return error
      }

      return error
    },
    async selectAddress(address)
    {
      var cart = ShoppingCart.cart[ShoppingCart.active_shopping_cart].products;
      var active_merchant = Merchant.getMerchant();

      if(cart.length)
      {
        
          var check_merchant_change = ShoppingCart.changeMerchant(address.brgy_code);
          check_merchant_change.then((updated_products)=>{

            if(updated_products.status == 'success' && updated_products.updated)
            {

              let displayed_product_data = {
                  subtotal: 0,
                  products: []
              };

              cart.forEach((product,product_index)=>{
                  var p = {
                    product: null,
                    quantity: 0
                  };

                  p.product = product.product;
                  updated_products.products.forEach((new_product, new_product_index)=>{
                      var sku_raw = product.product.sku.substring(0, product.product.sku.indexOf("-"));
                      if(new_product.product.sku.includes(sku_raw))
                      {
                        p.quantity = new_product.new_qty;
                      }
                  });

                  displayed_product_data.subtotal += (p.product.product_price) * p.quantity;
                  displayed_product_data.products.push(p);
              });

              console.log(displayed_product_data);

              let product_list_message = "<ul class='updated-product-list'>";
              displayed_product_data.products.forEach((dp, dp_i)=>{
                // if(dp.quantity>0)
                // {
                  product_list_message = product_list_message + "<li>" + dp.quantity + " x " + dp.product.product_name + "</li>";
                // }
              });
              product_list_message  = product_list_message + "</ul>";


              let subtotal_message = 'Subtotal: ' + displayed_product_data.subtotal;
              let custom_message = "There was a change in the available stock. Kindly refer to your updated cart. Please click “Proceed” to accept the changes and continue with your order."+product_list_message+"";
             
                 if(updated_products.change_quantity == true)
                {
                   this.$refs.confirmDialogue.show({
                        title: "Notice",
                        message: custom_message,
                        okButton: 'Proceed',
                        cancelButton: 'Cancel'
                    }).then((response)=>{

                      if(response == true)
                      {
                         if(!this.submitting)
                          {
                              this.submitting = true;
                              this.Account.setLoginId(this.stored_login_id);
                              this.Account.setToken(this.stored_token);
                              this.Account.setCustomerID(address.customer_id);
                              this.Account.setPasswordStatus(this.stored_temp_password);

                              var location = {
                                  "province": {
                                      "province_code": address.province_code,
                                      "province_name": address.province_name
                                  },
                                  "city": {
                                      "city_code": address.city_code,
                                      "city_name": address.city_name
                                  },
                                  "barangay": {
                                      "brgy_code": address.brgy_code,
                                      "brgy_name": address.brgy_name
                                  }
                              };

                              Merchant.setMerchant({
                                merchant_id: address.merchant_id,
                                merchant_weight_limit: address.merchant_weight_limit,
                              });

                              Location.setLocation(location);

                              // ShoppingCart.setCart(ShoppingCart.EMPTY_CART);

                                // Changed Login ID to CUstomer ID 07/18/2023
                              this.loadAccountCart(address.customer_id, this.stored_token, location.barangay.brgy_code, address.merchant_id , true).then((response)=>{
                                  if(this.$route.query.redirect)
                                  {
                                      this.$router.push({ name: this.$route.query.redirect });
                                  }
                                  else
                                  {
                                      this.$router.push('/');
                                  }

                              });

                          }

                      }
                      else
                      {


                      }
                    });
                }
                else
                {
                     if(!this.submitting)
                    {
                        this.submitting = true;
                        this.Account.setLoginId(this.stored_login_id);
                        this.Account.setToken(this.stored_token);
                        this.Account.setCustomerID(address.customer_id);
                        this.Account.setPasswordStatus(this.stored_temp_password);

                        var location = {
                            "province": {
                                "province_code": address.province_code,
                                "province_name": address.province_name
                            },
                            "city": {
                                "city_code": address.city_code,
                                "city_name": address.city_name
                            },
                            "barangay": {
                                "brgy_code": address.brgy_code,
                                "brgy_name": address.brgy_name
                            }
                        };

                        Merchant.setMerchant({
                          merchant_id: address.merchant_id,
                          merchant_weight_limit: address.merchant_weight_limit,
                        });

                        Location.setLocation(location);

                        // ShoppingCart.setCart(ShoppingCart.EMPTY_CART);

                          // Changed Login ID to CUstomer ID 07/18/2023
                        this.loadAccountCart(address.customer_id, this.stored_token, location.barangay.brgy_code, address.merchant_id , true).then((response)=>{
                            if(this.$route.query.redirect)
                            {
                                this.$router.push({ name: this.$route.query.redirect });
                            }
                            else
                            {
                                this.$router.push('/');
                            }

                        });

                    } 

                }

            }
            else
            {
                 if(!this.submitting)
                    {
                        this.submitting = true;
                        this.Account.setLoginId(this.stored_login_id);
                        this.Account.setToken(this.stored_token);
                        this.Account.setCustomerID(address.customer_id);
                        this.Account.setPasswordStatus(this.stored_temp_password);

                        var location = {
                            "province": {
                                "province_code": address.province_code,
                                "province_name": address.province_name
                            },
                            "city": {
                                "city_code": address.city_code,
                                "city_name": address.city_name
                            },
                            "barangay": {
                                "brgy_code": address.brgy_code,
                                "brgy_name": address.brgy_name
                            }
                        };

                        Merchant.setMerchant({
                          merchant_id: address.merchant_id,
                          merchant_weight_limit: address.merchant_weight_limit,
                        });

                        Location.setLocation(location);

                        // ShoppingCart.setCart(ShoppingCart.EMPTY_CART);

                          // Changed Login ID to CUstomer ID 07/18/2023
                        this.loadAccountCart(address.customer_id, this.stored_token, location.barangay.brgy_code, address.merchant_id , true).then((response)=>{
                            if(this.$route.query.redirect)
                            {
                                this.$router.push({ name: this.$route.query.redirect });
                            }
                            else
                            {
                                this.$router.push('/');
                            }

                        });

                    }
            }



          });

      }
      else
      {
        if(!this.submitting)
        {
            this.submitting = true;
            this.Account.setLoginId(this.stored_login_id);
            this.Account.setToken(this.stored_token);
            this.Account.setCustomerID(address.customer_id);
            this.Account.setPasswordStatus(this.stored_temp_password);

            var location = {
                "province": {
                    "province_code": address.province_code,
                    "province_name": address.province_name
                },
                "city": {
                    "city_code": address.city_code,
                    "city_name": address.city_name
                },
                "barangay": {
                    "brgy_code": address.brgy_code,
                    "brgy_name": address.brgy_name
                }
            };

            Merchant.setMerchant({
              merchant_id: address.merchant_id,
              merchant_weight_limit: address.merchant_weight_limit,
            });

            Location.setLocation(location);

            // ShoppingCart.setCart(ShoppingCart.EMPTY_CART);

              // Changed Login ID to CUstomer ID 07/18/2023
            this.loadAccountCart(address.customer_id, this.stored_token, location.barangay.brgy_code, address.merchant_id , true).then((response)=>{
                if(this.$route.query.redirect)
                {
                    this.$router.push({ name: this.$route.query.redirect });
                }
                else
                {
                    this.$router.push('/');
                }

            });

        }
      }
       
    },
    goToRegister()
    {
      var redirect_url = (this.$route.query.redirect ? this.$route.query.redirect : '');
      if(redirect_url != '')
      {
        this.$router.push({ path: '/register', query: { redirect: redirect_url }});
      }
      else
      {
        this.$router.push('/register');
      }
    },
    login () {
      this.show_error = false
      this.error_message = ''

      var validation = this.validate()
      if (validation.has_error) {
        this.submitting = false
        this.show_error = true
        this.error_message = validation.message
        this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      } else {
        this.submitting = true
        try {
          var login_request = AccountAPI.login(this.username.trim(), this.password.trim())
          login_request.then((response) => {
            if (response.status == 'failed') {
              this.submitting = false
              this.show_error = true
              this.error_message = response.error;

              this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
            }
            else
            {
               
                if(response.address_list.length > 1)
                {
                    this.valid_account = true;
                    this.stored_token = response.token;
                    this.stored_login_id = response.login_id;
                    this.stored_temp_password = response.temp_pass;

                    this.user_addresses = response.address_list;
                    Account.setAddresses(response.address_list);

                    this.submitting = false;
                }
                else if(response.address_list.length == 1)
                {

                 
                    Account.setLoginId(response.login_id);
                    Account.setToken(response.token);
                    Account.setPasswordStatus(response.temp_pass);
                    
                    var customer = response.address_list[0].customer_id;
                    Account.setCustomerID(customer);
                    
                    Account.setAddresses(response.address_list);

                    // var location = {
                    //     "province": {
                    //         "province_code": response.address_list[0].province_code,
                    //         "province_name": response.address_list[0].province_name
                    //     },
                    //     "city": {
                    //         "city_code": response.address_list[0].city_code,
                    //         "city_name": response.address_list[0].city_name
                    //     },
                    //     "barangay": {
                    //         "brgy_code": response.address_list[0].brgy_code,
                    //         "brgy_name": response.address_list[0].brgy_name
                    //     }
                    // };
                    // Location.setLocation(location);
                    // Merchant.setMerchant({
                    //   merchant_id: response.address_list[0].merchant_id,
                    //   merchant_weight_limit: (response.address_list[0].merchant_weight_limit == undefined || response.address_list[0].merchant_weight_limit == null ? 0 : response.address_list[0].merchant_weight_limit),
                    // });

                     var location = Location.getLocation();
                    this.loadAccountCart(customer, response.token, location.barangay.brgy_code,  response.address_list[0].merchant_id, true).then((response)=>{
                        this.submitting = false;
                        if(this.$route.query.redirect)
                        {
                            this.$router.push({ name: this.$route.query.redirect });
                        }
                        else
                        {
                            this.$router.push('/');
                        }

                    });

                   
                }
                else
                {
                    this.submitting = false
                    this.show_error = true
                    this.error_message = "No Address Found on this account"
                    this.$refs['title'].scrollIntoView({ behavior: 'smooth' })

                }
            }
          })
        } catch (error) {
          this.submitting = false
          this.show_error = true
          this.error_message = error
          this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  },
  data () {
    return {
      Account,
      show_error: false,
      error_message: '',
      username: '',
      password: '',
      show_password: false,
      submitting: false,
      valid_account: false,
      stored_login_id: '',
      stored_token: '',
      stored_temp_password: '',
      user_addresses: [],
    }
  }
}
</script>

<template>
  <div class="page login-page">
    <HeaderFive />

    <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="/static/img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                           
                            <h1 class="section-title white-color" ref="title">Account</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>Login</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- LOGIN AREA START -->
    <div class="ltn__login-area pb-65" >
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area ltn__section-title-2 text-center">
                        <h1 class="section-title h1">Sign In <br>To  Your Account</h1>
                        <p>Type your registered e-mail and password to access your account</p>
                    </div>
                     <div class="alert alert-danger" role="alert" v-if="show_error">{{ error_message }}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="account-login-inner" ref="signin">
                        <div action="#" class="ltn__form-box contact-form-box">
                            <div v-if="!valid_account">

                                <div class="input-item input-item-email">
                                <input type="email" v-model="username" name="u" placeholder="Username*">
                                </div>
                                <div class="input-item input-item-password mb-4">
                                    <input :type="(show_password ? 'text' : 'password')" v-model="password" name="p" placeholder="Password*">
                                    <i class="fas" :class="{ 'fa-eye': !show_password, 'fa-eye-slash': show_password }" @click="show_password = !show_password"></i>
                                </div>
                                <div class="btn-wrapper mt-0">
                                    <button @click="login" :disabled="submitting" class="theme-btn-1 button-1 btn btn-block" type="submit">{{ submitting ? 'SIGNING IN' : 'SIGN IN' }}</button>
                                </div>
                            </div>
                            <div v-if="valid_account">
                                <h4>Select an address to Proceed</h4>
                                <div class="address-list-container">
                                    <ul class="address-list">
                                        <li class="account-address" v-for="address in user_addresses" @click="selectAddress(address)">{{ address.brgy_name + ", " + address.city_name + ", " + address.province_name }}</li>
                                    </ul>

                                      <div class="spinner" v-if="submitting">
                                          <div class="dot1"></div>
                                          <div class="dot2"></div>
                                      </div>
                                </div>
                            </div>
                            <div class="go-to-btn mt-20">
                                <router-link to="/forgot-password"><small>FORGOT YOUR PASSWORD?</small></router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="account-create text-center pt-50">
                        <h4>DON'T HAVE AN ACCOUNT?</h4>
                       
                        <div class="btn-wrapper">
                            <button type="button" @click="goToRegister" class="theme-btn-1 button-1 btn black-btn">CREATE ACCOUNT</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- LOGIN AREA END -->
      <AlertDialogue ref="alertDialogue" />
      <ConfirmDialogue ref="confirmDialogue" />
    <Footer />
  </div>
</template>
<style>
ul.address-list {
        list-style-type: none;
    padding: 0;
    margin: 0;
    width: 100%;
}
ul.address-list li {
    border: 1px solid #e0e0e0;
    padding: 1rem;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 700;
    color: #343434;
}
ul.address-list li:hover {
    color: #0d0c85;
    transition: 0.3s all ease;
    /* color: #fff; */
    text-indent: 1rem;
    /* border-color: red; */
}
.address-list-container {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
}
.address-list-container .spinner {
    position: absolute;
    z-index: 999;
}


.input-item.input-item-password {
    display: flex;
    justify-content: center;
    align-items: center;
}
.input-item.input-item-password input {
    margin: 0;
}
.input-item.input-item-password .fas {
    position: absolute;
    right: 20px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Login.vue